import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useOrderLogDetail(id, params) {
  return useSWR(
    !!id && params?.warehouse
      ? {
          path: `/api/v1/orders/${id}/order-logs`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useOrderLogDetail;
